import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustBadges = [
  {
    icon: 'Shield',
    title: 'GDPR Compliant',
    description: 'Full compliance with EU data protection regulations'
  },
  {
    icon: 'Building2',
    title: 'Norwegian Business',
    description: 'Registered and compliant with Norwegian business law'
  },
  {
    icon: 'Lock',
    title: 'Secure Platform',
    description: 'Bank-level encryption and security measures'
  },
  {
    icon: 'Users',
    title: 'Trusted by 500+',
    description: 'Companies across Scandinavia'
  }];


  const testimonials = [
  {
    name: "Lars Andersen",
    company: "TechStart AS",
    role: "HR Director",
    content: "Workfolio revolutionized our hiring process. We found three excellent developers within a week, and the anonymous approach eliminated our unconscious bias.",
    avatar: "https://images.unsplash.com/photo-1585066047759-3438c34cf676",
    avatarAlt: "Professional headshot of middle-aged man with beard in dark suit"
  },
  {
    name: "Ingrid Haugen",
    company: "Nordic Solutions",
    role: "Talent Acquisition Manager",
    content: "The pay-per-unlock model is perfect for our budget. No more expensive subscriptions - we only pay when we find candidates worth contacting.",
    avatar: "https://images.unsplash.com/photo-1684262855358-88f296a2cfc2",
    avatarAlt: "Professional headshot of blonde woman in navy blazer smiling"
  }];


  return (
    <div className="space-y-8">
      {/* Trust Badges */}
      <div className="bg-card rounded-xl p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-6 text-center">
          Trusted & Compliant Platform
        </h3>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustBadges?.map((badge, index) =>
          <div key={index} className="text-center">
              <div className="w-12 h-12 bg-primary/10 rounded-xl flex items-center justify-center mx-auto mb-3">
                <Icon name={badge?.icon} size={24} className="text-primary" />
              </div>
              <h4 className="font-medium text-foreground text-sm mb-1">
                {badge?.title}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {badge?.description}
              </p>
            </div>
          )}
        </div>
      </div>
      {/* Customer Testimonials */}
      <div className="bg-card rounded-xl p-6 border border-border">
        <h3 className="text-lg font-semibold text-foreground mb-6 text-center">
          What Employers Say
        </h3>
        
        <div className="space-y-6">
          {testimonials?.map((testimonial, index) =>
          <div key={index} className="bg-muted/30 rounded-lg p-4">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
                  <img
                  src={testimonial?.avatar}
                  alt={testimonial?.avatarAlt}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.src = '/assets/images/no_image.png';
                  }} />

                </div>
                <div className="flex-1">
                  <p className="text-sm text-foreground mb-3 italic">
                    "{testimonial?.content}"
                  </p>
                  <div>
                    <div className="font-medium text-foreground text-sm">
                      {testimonial?.name}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {testimonial?.role} at {testimonial?.company}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Security Notice */}
      <div className="bg-gradient-to-r from-success/5 to-primary/5 rounded-lg p-4 border border-success/20">
        <div className="flex items-center space-x-3">
          <Icon name="ShieldCheck" size={24} className="text-success" />
          <div>
            <h4 className="font-medium text-foreground text-sm mb-1">
              Your Data is Protected
            </h4>
            <p className="text-xs text-muted-foreground">
              We use industry-standard encryption and never share your company information with third parties. All payments are processed securely through trusted Norwegian payment providers.
            </p>
          </div>
        </div>
      </div>
    </div>);

};

export default TrustSignals;